import Composer from "./Composer";

export default function App() {
  const year = new Date().getFullYear();

  return (
    <>
      <div className="grain" aria-hidden="true"></div>

      <header className="nav">
        <a className="brand" href="#top" aria-label="bobru.net home">
          bobru.net<sup className="brgr">μικρο</sup>
        </a>
        <nav className="nav-links" aria-label="Primary">
          <a href="#what">What it is</a>
          <a href="#why">Why bobru.net</a>
        </nav>
        <a className="btn btn-ghost" href="#claim">
          Claim your handle
        </a>
      </header>

      <main id="top">
        <section className="hero wrap">
          <p className="eyebrow">μικρά · blogs · since now</p>
          <h1>
            Big ideas,
            <br />
            <span className="gr mu">μικρά</span> <em>posts.</em>
          </h1>
          <p className="lede">
            <strong>bobru.net</strong> is the home for microblogs — tiny posts
            with everything to say. No feed engineered to enrage. No infinite
            scroll. Just small, good writing, in the order it was written.
          </p>
          <div className="cta-row">
            <a className="btn btn-solid" href="#claim">
              Start writing small
            </a>
            <a className="txt" href="#what">
              How it works →
            </a>
          </div>

          <Composer />
        </section>

        <div className="marquee" aria-hidden="true">
          <div className="mtrack">
            <span className="acc gr">μικρά</span><span>·</span><span>small posts</span><span>·</span><span>big presence</span><span>·</span><span>no algorithm</span><span>·</span><span>chronological</span><span>·</span><span>own your words</span><span>·</span>
            <span className="acc gr">μικρά</span><span>·</span><span>small posts</span><span>·</span><span>big presence</span><span>·</span><span>no algorithm</span><span>·</span><span>chronological</span><span>·</span><span>own your words</span><span>·</span>
          </div>
        </div>

        <section className="sec wrap" id="what">
          <div className="what">
            <div>
              <span className="sno">01</span>
              <h2 className="stitle">
                A blog the size
                <br />
                <em>of a thought.</em>
              </h2>
            </div>
            <div>
              <p className="gloss">
                <span className="word gr">μικροϊστολόγια</span>
                <span className="pos">noun · pl. · Greek</span> from μικρο-
                (small) + ιστολόγιο (web-log): micro-blogs. Exactly what
                bobru.net is.
              </p>
              <p>
                The web told us to write more, longer, louder. bobru.net is the
                quiet opposite. Every post fits inside a{" "}
                <span className="gr">μικρό</span> limit — small enough to read
                on a walk, sharp enough to remember.
              </p>
              <p>
                Less a platform, more a notebook you happen to share. Publish a
                single line, or thread a handful into a longer train of thought.
                Either way, it stays yours.
              </p>
            </div>
          </div>
        </section>

        <section className="sec wrap" id="why" style={{ paddingTop: 0 }}>
          <span className="sno">02</span>
          <h2 className="stitle">Small by design.</h2>
          <div className="why-grid">
            <div className="feat">
              <span className="fg gr">α</span>
              <h3>The μ-limit</h3>
              <p>
                A gentle ceiling on every post. Constraint isn't a cage — it's
                what makes you find the better word.
              </p>
            </div>
            <div className="feat">
              <span className="fg gr">β</span>
              <h3>Quiet by default</h3>
              <p>
                No ranking, no recommended-for-you, no outrage machine. Posts
                arrive in the order they were written.
              </p>
            </div>
            <div className="feat">
              <span className="fg gr">γ</span>
              <h3>Threads that breathe</h3>
              <p>
                Link micro-posts into a longer train of thought without writing
                an essay you didn't mean to.
              </p>
            </div>
            <div className="feat">
              <span className="fg gr">δ</span>
              <h3>Yours to keep</h3>
              <p>
                Full export, open RSS, a real account you own. Leave whenever
                and take every word with you.
              </p>
            </div>
          </div>
        </section>

        <section className="claim" id="claim">
          <div className="wrap">
            <p className="eyebrow">join the small web</p>
            <h2>
              Find your handle
              <br />
              before someone smaller does.
            </h2>
            <form className="cform" onSubmit={(e) => e.preventDefault()}>
              <label className="cfield">
                <span>bobru.net/@</span>
                <input
                  type="text"
                  autoComplete="off"
                  spellCheck={false}
                  placeholder="you"
                  aria-label="Your handle"
                />
              </label>
              <button
                className="btn btn-solid"
                type="submit"
                style={{ background: "var(--vermillion)" }}
              >
                Claim it
              </button>
            </form>
            <p className="cnote">
              free forever · no ads · no algorithm · just{" "}
              <span className="gr">μικρά</span>
            </p>
          </div>
        </section>
      </main>

      <footer className="foot wrap">
        <div className="foot-top">
          <div className="foot-brand">
            bobru.net<sup className="brgr">μικρο</sup>
            <p>Microblogs for people with something small to say.</p>
          </div>
          <nav className="fcols" aria-label="Footer">
            <div>
              <h4>Product</h4>
              <a href="#what">What it is</a>
              <a href="#why">Why bobru.net</a>
            </div>
            <div>
              <h4>Company</h4>
              <a href="#">About</a>
              <a href="#">Manifesto</a>
              <a href="#">Contact</a>
            </div>
            <div>
              <h4>Stay small</h4>
              <a href="#">RSS</a>
              <a href="#">Status</a>
              <a href="#">@bobru.net</a>
            </div>
          </nav>
        </div>
        <p className="ffine">
          © {year} bobru.net · made small, on purpose ·{" "}
          <span className="gr">μικρά</span>
        </p>
      </footer>
    </>
  );
}
